<template>
    <div id="redirect-page">
        <div class="container">
            <div class="row pt-4">
                <div class="col-12">
                    <p><i class="fas fa-sync fa-spin mr-2"></i>Redirecting...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Redirectr from "@/utils/Redirectr";

export default {
    name: "redirect-page",
    mounted() {
        let redirectr = new Redirectr(this.$route);

        if(redirectr.hasRedirect()) {
            location.href = redirectr.getRedirectUrl();
            return 
        }

        let homeUrl = "/";
        if(redirectr.hasMessage())
            homeUrl += `?message=${redirectr.messageType}`;

        location.href = homeUrl;
    }
}
</script>

